import { Base } from '../base-component';

import './supporting-content-item.component.scss';

export class SupportingContentItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/supporting-content-item/supporting-content-item.component.ts